import React from 'react';
import { NavLink } from 'react-router-dom';

export interface INavBarItemProps {
  text: string;
  linkTo: string;
}

const NavBarItem: React.FC<INavBarItemProps> = (props: INavBarItemProps) => {
  return (
    <div className="NavBarItem">
      <NavLink to={props.linkTo} className="NavBarItemLink" activeClassName="SelectedNavBarItemLink">{props.text}</NavLink>
    </div>
  );
}

export default NavBarItem;